import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './header-icon-button.module.scss'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'

/**
 * Кнопка поиска
 */
export const HeaderSearch = ({ onClick, className }) => {
  return (
    <button
      className={classNames(cls.iconButton, className)}
      onClick={onClick}
      type="button"
      aria-label="Поиск"
    >
      <MaterialIcon name="search" ariaLabel="Поиск" />
    </button>
  )
}

HeaderSearch.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
}
